<template>
  <el-dialog title="选择投标人" :visible.sync="dialogVisible" width="60%" @close="handleClose">
    <div style="margin-bottom: 15px;">
      <el-input
        v-model="searchKeyword"
        placeholder="搜索投标人名称"
        @input="handleSearch"
        style="width: 300px;">
        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
      </el-input>
    </div>
    
    <el-table
      :data="bidders"
      v-loading="loading"
      @row-click="handleSelect"
      style="width: 100%; cursor: pointer;">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="name" label="投标人名称" min-width="200"></el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
    </el-table>
    
    <div style="margin-top: 15px; text-align: center;">
      <el-pagination
        @current-change="handlePageChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        layout="prev, pager, next, total">
      </el-pagination>
    </div>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'BidderSelectDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      bidders: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchKeyword: ''
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.searchKeyword = ''
        this.currentPage = 1
        this.loadData()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize
        }
        if (this.searchKeyword) {
          params.keyword = this.searchKeyword
        }
        
        const response = await this.$http.get('/import/bidders', { params })
        const data = response.data.data || response.data
        this.bidders = data.items || data
        this.total = data.total || data.length
      } catch (error) {
        this.$message.error('加载投标人列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    
    handlePageChange(page) {
      this.currentPage = page
      this.loadData()
    },
    
    handleSelect(row) {
      this.$emit('select', row)
      this.dialogVisible = false
    },
    
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>
